import { beneficiaryQuery } from "@/api/airWallex";
import { queryClient } from "@/api/utils";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, number, object, optional, pipe, string, toMinValue } from "valibot";

export const Route = createFileRoute("/supplier/$supplierId/settings/payment")({
  validateSearch: object({
    q: fallback(optional(string(), ""), ""),
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
  }),
  component: lazyRouteComponent(() => import("./+PaymentPage")),
  loader: ({ params }) => {
    queryClient.prefetchQuery(beneficiaryQuery(params.supplierId));
  },
  head: () => ({
    meta: seo({ title: "Payment Details" }),
  }),
});
